// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDVVnwozHvDwsHshHManT2moPNZIdRML3U",
  authDomain: "dytkerem-9e290.firebaseapp.com",
  projectId: "dytkerem-9e290",
  storageBucket: "dytkerem-9e290.firebasestorage.app",
  messagingSenderId: "140826763102",
  appId: "1:140826763102:web:332954a3a98b0408b839cf",
  measurementId: "G-48R64TV1GT"
};

// Firebase'i başlat
const app = initializeApp(firebaseConfig);

// Auth, Firestore ve Storage servislerini export et
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;